<div class="modal-header">
  <h5 class="modal-title">{{'acquisti.prodImport.title' | translate}}</h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row" >
    <div class="col-sm-12 col-md-12">
      <app-import-component #ImportComponent (Uploaded)="uploaded($event)" [isModal]="false" ></app-import-component>
    </div>
  </div>
</div>
